import { createContext } from 'react';
import { AbTestingClient } from '@src/@types/ab-testing';

export type AbTestingContextShape = {
  abTestingEnabled: boolean;
  abTestingInitialized: boolean;
  initializationError: Error | null;
  abTestingClient: AbTestingClient;
};

export const AbTestingContext = createContext<AbTestingContextShape>({
  abTestingEnabled: false,
  abTestingInitialized: false,
  initializationError: null,
  abTestingClient: null,
});
